(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-tab"] && !window.DesignMode) return;
  try {
    
// JavaScript code to handle button clicks and display collections
$(document).ready(function() {
  function showCollection(collectionId) {
    $('.collection-content').hide(); // Hide all collections
    $('#' + collectionId).show(); // Show the selected collection

    // Update URL
    var newUrl = window.location.href.split('?')[0] + '?collection=' + collectionId;
    history.pushState(null, null, newUrl);
  }

  $('.collection-button').click(function() {
    var collectionId = $(this).data('collection');
    showCollection(collectionId);
  });

  $('.collection-dropdown').change(function() {
    var collectionId = $(this).val();
    showCollection(collectionId);
  });

  // Show the first collection by default
  $('.collection-content').first().show();

  // Check if a collection query parameter is present in the URL
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('collection')) {
    var collectionId = urlParams.get('collection');
    showCollection(collectionId); // Show the collection based on the query parameter
  }
});

  } catch(e) { console.error(e); }
})();

})();
